import ImportDataRoute from './ImportDataRoute';

export default {
  name: 'ImportDataRoute',
  location: '/le/import-data',
  component: ImportDataRoute,
};
